import { render, staticRenderFns } from "./upload_dist.vue?vue&type=template&id=5985a239&scoped=true"
import script from "./upload_dist.vue?vue&type=script&lang=js"
export * from "./upload_dist.vue?vue&type=script&lang=js"
import style0 from "./upload_dist.vue?vue&type=style&index=0&id=5985a239&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5985a239",
  null
  
)

export default component.exports